import { dot } from "./dot.js";
import { maddN } from "./maddn.js";
export const reflect = (out, a, b) => maddN(out || a, b, -2 * dot(a, b), a);
